import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://elittaksibodrum.com/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request interceptor - Token ekle
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('admin_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - Hata yönetimi
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('admin_token');
            window.location.href = '/admin/login';
        }
        return Promise.reject(error);
    }
);

// Araç API'leri
export const vehicleAPI = {
    getAll: () => api.get('/vehicles'),
    getById: (id) => api.get(`/vehicles/${id}`),
    checkAvailability: (id, date) => api.get(`/vehicles/${id}/availability`, { params: { date } }),
    
    // Admin endpoints
    getAllAdmin: () => api.get('/vehicles/admin/all'),
    create: (data) => api.post('/vehicles/admin/create', data),
    update: (id, data) => api.put(`/vehicles/admin/${id}`, data),
    delete: (id) => api.delete(`/vehicles/admin/${id}`),
    uploadImages: (id, formData) => api.post(`/vehicles/admin/${id}/images`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }),
    deleteImage: (id, imagePath) => api.delete(`/vehicles/admin/${id}/images`, { data: { imagePath } })
};

// Rezervasyon API'leri
export const reservationAPI = {
    create: (data) => api.post('/reservations', data),
    getAvailableVehicles: (params) => api.get('/reservations/available-vehicles', { params }),
    
    // Admin endpoints
    getAll: (params) => api.get('/reservations/admin/all', { params }),
    getById: (id) => api.get(`/reservations/admin/${id}`),
    updateStatus: (id, status) => api.put(`/reservations/admin/${id}/status`, { status }),
    delete: (id) => api.delete(`/reservations/admin/${id}`),
    getStats: () => api.get('/reservations/admin/stats/summary')
};

// Auth API'leri
export const authAPI = {
    login: (credentials) => api.post('/auth/login', credentials),
    hashPassword: (password) => api.post('/auth/hash-password', { password })
};

export default api;
